import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LOGO_MARK } from "../lib/brand";
import { LogoMark } from "../components/Logo";

export default function NwrCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const ran = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    if (!code || !state) {
      setErr("Fehlender code/state");
      setTimeout(() => navigate("/login", { replace: true }), 2000);
      return;
    }
    const redirect_uri = `${window.location.origin}${location.pathname}`;
    (async () => {
      try {
        const { data } = await api.post("/auth/nwr/callback", { code, state, redirect_uri });
        setUser(data.user);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        setErr(formatApiError(e));
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LogoMark src={LOGO_MARK} size="w-14 h-14" className="mx-auto animate-pulse" />
        <div className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-white/60">NWR ID Login läuft…</div>
        {err && <div className="mt-3 text-red-400 text-sm font-mono">{err}</div>}
      </div>
    </div>
  );
}
